import { Loader2 } from "lucide-react";
import { cn } from "@hipotecar/ui/lib/utils";

interface LoadingStateProps {
	message?: string;
	size?: "sm" | "md" | "lg";
	className?: string;
}

const sizeClasses = {
	sm: "h-6 w-6",
	md: "h-10 w-10",
	lg: "h-16 w-16",
};

const textSizeClasses = {
	sm: "text-xs",
	md: "text-sm",
	lg: "text-base",
};

export default function LoadingState({
	message,
	size = "md",
	className = "",
}: LoadingStateProps) {
	return (
		<div
			className={cn(
				"flex flex-col items-center justify-center py-12 duration-300 animate-in fade-in",
				className,
			)}
		>
			<Loader2
				className={cn(
					"mb-4 animate-spin text-brand-500 dark:text-brand-400",
					sizeClasses[size],
				)}
			/>
			{message && (
				<p className={cn("text-secondary", textSizeClasses[size])}>{message}</p>
			)}
		</div>
	);
}
